import { IGetUIProfileConfigParams } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

import { IUserProfileConfig } from '../types';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { getUIProfileConfig },
  useGetUIProfileConfigQuery,
  useLazyGetUIProfileConfigQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    getUIProfileConfig: build.query<
      IUserProfileConfig,
      IGetUIProfileConfigParams | void
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const service = MultiService.getService();

          const response = await service
            .getAccountingGateway()
            .getUIProfileConfig(params ?? undefined);

          let uiConfig: IUserProfileConfig = {};

          if (response?.ui_config) {
            try {
              uiConfig = JSON.parse(response?.ui_config) as IUserProfileConfig;
            } catch (e) {
              throw new Error(`Failed to parse UI config: ${e}`, { cause: e });
            }
          }

          return {
            data: uiConfig,
          };
        },
      }),
      providesTags: (_result, _error, { group } = {}) => [
        { type: RequestType.ProfileConfig, group },
      ],
    }),
  }),
});

export const {
  selectDataCachedByParams: selectUIProfileConfig,
  selectLoadingCachedByParams: selectUIProfileConfigLoading,
} = createQuerySelectors({ endpoint: getUIProfileConfig });
